<button class="filter-btn" (click)="filterSidenav.toggle()">
  <!-- <i class="bi bi-funnel"></i> -->
  <img alt="" src="../../../../assets/images/icons/filter-icon.svg" />
  <span class="px-2">{{ "Filter" | translate }}</span>
</button>

<mat-sidenav-container
  #sidenav
  class="example-container"
  [hasBackdrop]="true"
  [autosize]="true"
  [ngClass]="{ 'd-none': !filterSidenav.opened }">
  <mat-sidenav
    #filterSidenav
    mode="side"
    opened="false"
    [fixedInViewport]="true"
    position="end"
    class="filterSideNav">
    <div class="header">
      <span>{{ "Filters" | translate }}</span>
      <button
        type="button"
        class="icon-wrapper cursor-pointer btn-reset"
        [attr.aria-label]="'Aria.Close' | translate"
        (click)="filterSidenav.toggle()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="content">
      <ng-content></ng-content>
    </div>

    <div class="footer">
      <span
        class="danger font-bold font-16 cursor-pointer"
        (click)="resetFiltersEvent.emit()"
        >{{ "Reset-All-Filters" | translate }}</span
      >
      <button class="primary" (click)="applyFiltersEvent.emit()">
        {{ "Apply" | translate }}
      </button>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
